<div class="rfq-product-info__wrapper">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="">Product Type</label>
              <mat-select
                class="lum-select"
                formControlName="type"
                (selectionChange)="onChangeType()"
              >
                <mat-option *ngFor="let type of productTypes" [value]="type">
                  {{ type }}
                </mat-option>
              </mat-select>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="">Product Name</label>
              <input
                type="text"
                class="lum-input"
                formControlName="product_name"
                [required]="true"
              />
              <mat-error *ngIf="productNameControl && productNameControl.invalid">{{
                productNameControl | validateField
              }}</mat-error>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="">Internal SKU</label>
              <input
                type="text"
                class="lum-input"
                formControlName="internal_sku"
                [required]="true"
              />
              <mat-error *ngIf="internalSkuControl && internalSkuControl.invalid">{{
                internalSkuControl | validateField
              }}</mat-error>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="">UPC</label>
              <input type="text" class="lum-input" formControlName="upc" />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="">Product Category</label>
              <mat-select class="lum-select" formControlName="product_category_id">
                <mat-option
                  *ngFor="let category of productCategories"
                  [value]="category.id"
                >
                  {{ category.product_category }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="productCategoryControl && productCategoryControl.invalid"
                >{{ productCategoryControl | validateField }}</mat-error
              >
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="">Preferred Supplier</label>
              <mat-select class="lum-select" formControlName="preferred_vendor_id">
                <mat-option *ngFor="let factory of factories" [value]="factory.id">
                  {{ factory.factory_name }}
                </mat-option>
              </mat-select>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="">Tax Category</label>
              <input class="lum-input" formControlName="tax_category" />
            </div>
          </div>
          <div class="col-12" *ngIf="lotTrackingEnabled">
            <div class="form-group">
              <mat-checkbox class="lum-checkbox" formControlName="lot_tracking">
                Lot Tracking
              </mat-checkbox>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div
            class="col-md-12"
            *ngIf="featureFlag.REMOVE_PRODUCT_DEPARTMENT | featureFlag"
          >
            <div class="form-group">
              <label for="">Product Department</label>
              <mat-select class="lum-select" formControlName="product_dept_id">
                <mat-option
                  *ngFor="let department of departments"
                  [value]="department.id"
                >
                  {{ department.text }}
                </mat-option>
              </mat-select>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="">Re-Order Level</label>
                  <input
                    type="number"
                    class="lum-input"
                    min="0"
                    formControlName="reorder_level"
                  />
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label for="">Low Stock Alert Quantity</label>
                  <input
                    type="number"
                    class="lum-input"
                    min="0"
                    formControlName="qty_limit_notify"
                  />
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label for="">Minimum Stock</label>
                  <input
                    type="number"
                    class="lum-input"
                    min="0"
                    formControlName="oss_limit_notify"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label for="">Wholesale Price</label>
                  <input
                    type="number"
                    class="lum-input"
                    min="0"
                    formControlName="wholesale_price"
                  />
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label for="">Retail Price</label>
                  <input
                    type="number"
                    class="lum-input"
                    min="0"
                    formControlName="retail_price"
                  />
                </div>
              </div>
              <div *ngIf="dialogData.permissions?.viewUnitCost" class="col-4">
                <div class="form-group">
                  <label for="">Unit Cost</label>
                  <input
                    type="number"
                    class="lum-input"
                    min="0"
                    formControlName="unitCost"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label>
                <mat-checkbox
                  formControlName="quote_expires"
                  class="lum-checkbox"
                  [checked]="quote_expires"
                  (change)="quote_expires = !quote_expires"
                  >Quote expires?</mat-checkbox
                >
              </label>
              <input
                *ngIf="quote_expires"
                type="date"
                class="lum-input"
                formControlName="expires_at"
              />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <mat-checkbox
                class="lum-checkbox"
                formControlName="internal_use_only"
              >
                Internal Use Only
              </mat-checkbox>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label for="">Product Tags</label>
              <lum-filter-tag
                ngDefaultControl
                formControlName="product_tags"
                label=""
                (onFilterSelect)="onSetTags($event)"
              ></lum-filter-tag>
            </div>
          </div>
          <div class="col-12" *ngIf="!newKitsStructureEnabled">
            <div class="form-group">
              <label for="">Unit Class</label>
              <mat-select class="lum-select" formControlName="unit_class_id">
                <mat-option *ngFor="let unit of unitClasses" [value]="unit.id">
                  {{ unit.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="unitClassIdControl && unitClassIdControl.invalid">{{
                unitClassIdControl | validateField
              }}</mat-error>
            </div>
          </div>
          <div class="col-12" *ngIf="!newKitsStructureEnabled">
            <div class="form-group">
              <label for="">Selling Unit</label>
              <mat-select
                class="lum-select"
                formControlName="default_selling_unit_id"
              >
                <mat-option
                  *ngFor="let unit of unitMeasures?.data"
                  [value]="unit.id"
                >
                  {{ unit.name }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="
                  defaultSellingUnitIdControl && defaultSellingUnitIdControl.invalid
                "
                >{{ defaultSellingUnitIdControl | validateField }}</mat-error
              >
            </div>
          </div>
          <div class="col-12" *ngIf="!newKitsStructureEnabled">
            <div class="form-group">
              <label for="">Purchase Unit</label>
              <mat-select
                class="lum-select"
                formControlName="default_purchase_unit_id"
              >
                <mat-option
                  *ngFor="let unit of unitMeasures?.data"
                  [value]="unit.id"
                >
                  {{ unit.name }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="
                  defaultPurchaseUnitIdControl &&
                  defaultPurchaseUnitIdControl.invalid
                "
                >{{ defaultPurchaseUnitIdControl | validateField }}</mat-error
              >
            </div>
          </div>
          <div class="col-12" *ngIf="!newKitsStructureEnabled">
            <div class="form-group">
              <label for="">Default Receiving Bin</label>
              <mat-select
                class="lum-select"
                formControlName="default_receiving_bin_id"
              >
                <mat-option
                  *ngFor="let location of binLocations"
                  [value]="location.id"
                >
                  {{ location.location_name }}
                </mat-option>
              </mat-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label
            >Product Links
            <small>Please provide the product links in the market.</small>
          </label>
          <div formArrayName="product_links">
            <ng-container
              *ngFor="let link of productLinksControl?.controls; let idx = index"
            >
              <div [formGroupName]="idx" class="flex gap-2 mb-2">
                <input type="text" class="lum-input" formControlName="lv" />
                <div class="grow-0">
                  <ng-container *ngIf="idx === 0; else removeLink">
                    <button
                      class="lum-button w-20"
                      mat-icon-button
                      (click)="onAddLink()"
                    >
                      <lum-ui-icon
                        icon="add-1"
                        [width]="16"
                        [height]="16"
                        color="#ffffff"
                      ></lum-ui-icon>
                    </button>
                  </ng-container>
                  <ng-template #removeLink>
                    <button
                      class="lum-button lum-button--secondary w-20"
                      mat-icon-button
                      (click)="onRemoveLink(idx)"
                    >
                      <lum-ui-icon
                        icon="minus-circle"
                        [width]="16"
                        [height]="16"
                        color="#3a47af"
                      ></lum-ui-icon>
                    </button>
                  </ng-template>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label
            >Materials
            <small>Please provide the product list of materials.</small>
          </label>
          <div formArrayName="material">
            <ng-container
              *ngFor="let link of materialsControl?.controls; let idx = index"
            >
              <div [formGroupName]="idx" class="flex gap-2 mb-2">
                <input type="text" class="lum-input" formControlName="mv" />
                <div class="grow-0">
                  <ng-container *ngIf="idx === 0; else removeLink">
                    <button
                      class="lum-button w-20"
                      mat-icon-button
                      (click)="onAddMaterial()"
                    >
                      <lum-ui-icon
                        icon="add-1"
                        [width]="16"
                        [height]="16"
                        color="#ffffff"
                      ></lum-ui-icon>
                    </button>
                  </ng-container>
                  <ng-template #removeLink>
                    <button
                      class="lum-button lum-button--secondary w-20"
                      mat-icon-button
                      (click)="onRemoveMaterial(idx)"
                    >
                      <lum-ui-icon
                        icon="minus-circle"
                        [width]="16"
                        [height]="16"
                        color="#3a47af"
                      ></lum-ui-icon>
                    </button>
                  </ng-template>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label for="">Link to Product Photo</label>
          <input type="text" class="lum-input" formControlName="photo" />
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label for="">Product Description</label>
          <angular-editor
            formControlName="product_description"
            [config]="textEditorConfig"
            [placeholder]="'Enter text here...'"
          ></angular-editor>
        </div>
      </div>
    </div>
  </form>
</div>
